<template>
  <div>
    <el-row class="detail-header-wrap">
      <BaseHeader
          title="パスワード変更"
          icon="account-setting"
          class="password-header" />
    </el-row>
    <el-row>
      <el-col :span="8">
        <div class="table-vertical">
          <div class="table-header">
            <div class="table-header-btns">
              <BaseButton @click="save()">
                保存
              </BaseButton>
            </div>
          </div>
          <BaseTableDetail
              :table-set-list="setList"
              :display-item="values"
              :editable="editable" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<style scoped>
.table-vertical >>> .multipleLines .is-error-msg {
  white-space: pre-line;
  margin-top: -12px;
  margin-bottom: -6px;
}
</style>
<script>
import _ from 'lodash'
import { mapState } from 'vuex'

import * as config from '@/config'
import * as define from '@/define'
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import common from '@/utils/common'
import message from '@/utils/message'

import BaseButton from '@/components/atoms/BaseButton'
import BaseHeader from '@/components/molecules/BaseHeader'
import BaseTableDetail from '@/components/molecules/BaseTableDetail'

export default {
  name: 'ChangePassword',
  components: {
    BaseButton,
    BaseHeader,
    BaseTableDetail
  },
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      values: {
        current: '',
        password: '',
        passwordConfirm: ''
      },
      passwordConfirmed: true
    }
  },
  computed: {
    ...mapState({
      accountUuid: (state) => state.accountUuid,
      account: (state) => state.accountId
    }),
    setList () {
      return [
        {
          label: '現在のパスワード',
          properties: [
            {
              path: 'current', type: 'String', editableId: 'password', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required', validateAs: 'パスワード', password: true
            }
          ]
        },
        {
          label: '新しいパスワード',
          properties: [
            {
              path: 'password', type: 'String', editableId: 'password', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:50|passwordPolicy', validateAs: 'パスワード', password: true, class: 'multipleLines'
            }
          ]
        },
        {
          label: '新しいパスワードの確認',
          properties: [
            {
              path: 'passwordConfirm', type: 'String', editableId: 'password', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:50|confirmPassword', validateAs: 'パスワード', password: true
            }
          ]
        }
      ]
    },
    editable () {
      return { password: true }
    }
  },
  watch: {
    'values.password' (val) {
      this.confirmPassword()
    },
    'values.passwordConfirm' (val) {
      this.confirmPassword()
    }
  },
  created () {
    // パスワードポリシーのチェック
    this.$validator.extend('passwordPolicy', {
      getMessage: (field, rule, data) => {
        return common.getPasswordPolicyErrorMessage(data)
      },
      validate: () => {
        return common.checkPasswordPolicyResult(this.account, this.values.password)
      }
    })
    this.$validator.extend('confirmPassword', {
      getMessage: () => 'パスワードが一致しません。',
      validate: () => {
        return this.passwordConfirmed
      }
    })
  },
  methods: {
    async save () {
      if (!await this.$validator.validate()) {
        return
      }
      this.$confirm('パスワードを変更しますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(async () => {
        try {
          this.$loadingService.show()
          await this.changePassword(this.values.current, this.values.password)
          this.$notify.success('パスワードを変更しました。')
          this.values = {
            current: '',
            password: '',
            passwordConfirm: ''
          }
        } catch (error) {
          const data = _.get(error, 'response.data')
          if (data == null) {
            common.addError(error, { msg: message.MSG_502() })
          } else {
            const code = _.get(data, 'code')
            const reason = _.get(data, 'reason')
            if (code === 500 && reason === 'パスワード不一致') {
              common.addError(error, { msg: message.MSG_520() })
            } else {
              common.addError(error, { msg: message.MSG_518() })
            }
          }
          this.$notify.error({ error: error })
          throw error
        } finally {
          this.$loadingService.close()
        }
      }).catch((reason) => {
        if (reason === 'cancel') {
          this.$notify.info('キャンセルしました。')
        }
      })
    },
    async changePassword (current, password) {
      const url = `${config.ACCOUNT_URL}/${this.accountUuid}/password`
      const method = 'put'
      const data = {
        'current': current,
        'password': password
      }
      const response = await common.apiAxios(url, { method, data })
      return response
    },
    confirmPassword () {
      this.passwordConfirmed = this.values.password === this.values.passwordConfirm
      if (this.values.password !== '' && this.values.passwordConfirm !== '') {
        this.$validator.validate()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/account/ChangePassword.vue